export default "__VITE_ASSET__c36c2b92__"